/** @jsx jsx */
import { jsx } from 'theme-ui';
import { TextField } from './TextField';
import { Skeleton } from './Skeleton';
export var TextFieldSkeleton = function (_a) {
    var className = _a.className;
    return (jsx(TextField, { as: Skeleton, className: className }, "\u00A0"));
};
//# sourceMappingURL=TextFieldSkeleton.js.map